module.exports = __webpack_public_path__ + "static/media/bgbanner.265eef8b.jpg";